<template>
  <div class="back-stage">
    <header class="primary-title">
      <h1 class="head">
        <template v-if="!cId">
          <img class="logo" src="/src/assets/dataVisual/logo.svg" alt="">
          <span class="txt">政务系统数据可视化平台</span>
        </template>
        <span class="txt" v-else>{{communityName}}小区数据可视化平台</span>
      </h1>
    </header>
    <main class="main-box">
      <section class="sec-l">
        <ul class="list">
          <!--用户总数-->
          <user-count></user-count>

          <new-increased></new-increased>

          <open-num></open-num>
        </ul>
      </section>
      <section class="sec-c">
        <!--基础数据-->
        <base-data></base-data>

        <ul class="list">
          <!--实时开门数据-->
          <real-open></real-open>

          <!--小区用户数或单元用户数列表-->
          <community-user-num></community-user-num>
        </ul>
      </section>
      <section class="sec-r">
        <ul class="list">
          <x-weather></x-weather>

          <!--报事保修统计-->
          <repair></repair>

          <template v-if="!cId">
            <li class="pie-box">
              <div class="termin">
                <h3><i class="iconfont iconicon_jiantou"></i>累计终端分布</h3>
                <div id="termin"></div>
              </div>
              <div class="active-user">
                <h3><i class="iconfont iconicon_jiantou"></i>近7日活跃用户占比</h3>
                <div id="active-user"></div>
              </div>
            </li>

            <li class="list-item weekly-num">
              <h3><i class="iconfont iconicon_jiantou"></i>近7日小区开门数统计TOP10</h3>
              <section class="weekly-title">
                <p class="head">
                  <span class="txt">社区名称</span>
                  <span class="txt">总数</span>
                </p>
              </section>
              <div class="weekly-list hidden-scrollbar">
                <p v-for="(item, index) of weekly.list" :class="{scroll: weekly.isScroll && index===0}"  :key="index">
                  <span class="txt">{{item.name}}</span>
                  <span class="txt">{{item.num}}</span>
                </p>
              </div>
            </li>
          </template>

          <template v-else>
            <li class="verify">
              <div>
                <h1>{{userApply}}</h1>
                <p>
                  <img class="household" src="/src/assets/dataVisual/icon_zhuhu.svg" alt="">
                  <span>待审核住户申请</span>
                </p>
              </div>
              <div>
                <h1>{{keyApply}}</h1>
                <p>
                  <img class="key" src="/src/assets/dataVisual/icon_key.svg" alt="">
                  <span>待审核钥匙申请</span>
                </p>
              </div>
            </li>

            <li class="pie-box ht">
              <div class="termin">
                <h3><i class="iconfont iconicon_jiantou"></i>累计终端分布</h3>
                <div id="termin"></div>
              </div>
              <div class="active-user">
                <h3><i class="iconfont iconicon_jiantou"></i>近7日活跃用户占比</h3>
                <div id="active-user"></div>
              </div>
            </li>
          </template>
        </ul>
      </section>
    </main>

    <div class="search-btn" @click="openModal">
      <a-icon type="search" />
    </div>

    <select-community ref="selectCommunity"></select-community>
  </div>
</template>

<script>
import { addEdit, inputSearch } from 'ant-design-vue-admin-x';
import { fetchSelect } from '@/utils/mixins';
import mixins from '../../utils/mixins/dataViews/dataVis_mixin';
import {
  weather,
  newincreased,
  openNum,
  repair,
  communityUserNum,
  userCount,
  baseData,
  realOpen,
  selectCommunity
} from '@/components/dataviews/index';

export default {
  name: 'dataVisual',
  mixins: [
    mixins,
    addEdit,
    inputSearch,
    fetchSelect
  ],
  components: {
    XWeather: weather,
    NewIncreased: newincreased,
    OpenNum: openNum,
    repair,
    CommunityUserNum: communityUserNum,
    UserCount: userCount,
    BaseData: baseData,
    RealOpen: realOpen,
    SelectCommunity: selectCommunity
  },
  data () {
    return {
      cId: '',
      // 总数据
      backDataInterval: '',
      weekly: { isScroll: false, interval: {}, list: [] },
      // 单个小区数据
      selectedItem: {},
      userApply: 0,
      keyApply: 0,
      communityName: ''
    };
  },
  created () {
    this.getDataViewQuery(this);
    this.getOpenTop();
  },
  methods: {
    // reqesetAll () {
    //   axios.all([this.getCommunityTop(), this.getOpenTop()]).then(axios.spread((acct, perms) => {
    //     clearInterval(this.userSort.interval);
    //     clearInterval(this.weekly.interval);
    //     this.carousel(this.userSort);
    //     this.carousel(this.weekly);
    //   }));
    // },
    openModal () {
      this.$refs.selectCommunity.openModal();
    },
    /* 获取一周开门数据前10名 */
    getOpenTop () {
      this.$get({
        url: '/zw_statistics/community_open_top',
        params: { community_id: this.cId },
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.weekly.list = data.sort(this.compareFn('num'));
        } else {
          this.weekly.list = [];
        }
      });
    },
    /* 获取审核状态 */
    getVerifyStatus () {
      this.$get({
        url: '/zw_statistics/wait_check_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        this.keyApply = data.key_apply;
        this.userApply = data.householder_apply;
      });
    }
  },
  beforeDestroy () {
    clearInterval(this.weekly.interval);
    // clearInterval(this.backDataInterval);
    clearInterval(this.actionInterval); // 两页面公用方法的interval
    clearInterval(this.communityInterval);
  }
};
</script>

<style lang="scss">
@import '../../style/dataVisual/modules';
@import '../../style/dataVisual/common';
@import '../../style/dataVisual/variable';
@import '../../style/dataVisual/iconfont/iconfont.css';
@import '../../style/dataVisual/font/custom.css';
</style>
